import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const BadgesColumn = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('100')};
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
`;
